import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatDateAr(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('ar-SA', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function truncate(str, length = 100) {
  if (!str) return '';
  return str.length > length ? str.substring(0, length) + '...' : str;
}

export function getStatusColor(status) {
  const colors = {
    new: 'bg-blue-500/10 text-blue-500 border-blue-500/20',
    read: 'bg-gray-500/10 text-gray-400 border-gray-500/20',
    in_progress: 'bg-yellow-500/10 text-yellow-500 border-yellow-500/20',
    awaiting_approval: 'bg-orange-500/10 text-orange-500 border-orange-500/20',
    completed: 'bg-green-500/10 text-green-500 border-green-500/20',
    pending: 'bg-yellow-500/10 text-yellow-500 border-yellow-500/20',
    approved: 'bg-green-500/10 text-green-500 border-green-500/20',
    rejected: 'bg-red-500/10 text-red-500 border-red-500/20',
    draft: 'bg-gray-500/10 text-gray-400 border-gray-500/20',
    sent: 'bg-blue-500/10 text-blue-500 border-blue-500/20',
  };
  return colors[status] || colors.draft;
}

export function getFileIcon(fileType) {
  const icons = {
    pdf: 'FileText',
    docx: 'FileText',
    doc: 'FileText',
    xlsx: 'Table',
    xls: 'Table',
    dwg: 'PenTool',
    dxf: 'PenTool',
    image: 'Image',
    txt: 'FileText',
  };
  return icons[fileType] || 'File';
}
